import React from "react";
import { useNavigate } from "react-router-dom";
import LoanSteps from "./Loansteps";
import CallToAction from "./CallToAction";

const PropertyExhibitionInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section property-exhibition-fin">
                <h2 className="other-pages-title">Property Exhibition</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/property-exhibition-mumbai-thane-palghar-maharashtra-delhi-india")} style={{ cursor: "pointer" }}>Property Exhibition</span>
                </p>
            </div>
            <div className="info-loan-card-smco">
                <h2 className="info-loan-title-smco">What is Property Exhibition?</h2>

                <p className="info-loan-description-smco">
                    Property exhibition services involve showcasing real estate projects, properties, and developments to potential buyers, investors, and stakeholders. These exhibitions provide a platform for developers, builders, and real estate agents to display their offerings through interactive displays, virtual tours, model apartments, and marketing materials. Property exhibitions help bridge the gap between sellers and buyers, facilitating informed decisions and successful transactions.
                    <br /><br />
                    Exhibitions can be physical events at dedicated venues or virtual platforms using advanced technology. They typically include detailed project presentations, site plans, floor layouts, pricing information, and financing options. Professional organizers ensure a seamless experience, attracting qualified leads and generating buzz around new developments.
                    <br /><br />
                    The cost of organizing or participating in property exhibitions varies based on scale, location, and services included. Physical exhibitions may involve booth rentals, setup costs, and marketing expenses, while virtual events focus on digital tools and online promotion. Exhibitions are timed to coincide with market trends, festivals, or economic conditions for maximum impact.
                    <br /><br />
                    Property exhibitions are crucial for the real estate industry, enabling developers to launch projects, agents to expand networks, and buyers to explore options. Effective exhibitions combine creativity, data-driven insights, and personalized interactions to drive sales and build brand reputation.
                </p>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Key Features of Property Exhibition</h3>
                    <ul className="info-feature-list-smco">
                        <li><strong>Interactive displays:</strong> Model homes, virtual reality tours, and multimedia presentations.</li>
                        <li><strong>Targeted audience:</strong> Attract qualified buyers, investors, and industry professionals.</li>
                        <li><strong>Comprehensive information:</strong> Detailed project specs, pricing, amenities, and location advantages.</li>
                        <li><strong>Networking opportunities:</strong> Connect with agents, financiers, and potential partners.</li>
                        <li><strong>Lead generation:</strong> Capture contact details and follow up with interested prospects.</li>
                        <li><strong>Brand visibility:</strong> Showcase company expertise and past project successes.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Eligibility and Participation</h3>
                    <ul className="info-eligibility-list-smco">
                        <li><strong>Project readiness:</strong> Completed or near-completion projects with necessary approvals.</li>
                        <li><strong>Marketing materials:</strong> High-quality brochures, videos, and presentation materials.</li>
                        <li><strong>Budget allocation:</strong> Funds for booth setup, staffing, and promotional activities.</li>
                        <li><strong>Legal compliance:</strong> RERA registration and all required documentation.</li>
                        <li><strong>Target market:</strong> Clear understanding of the audience and market segment.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Costs and Planning</h3>
                    <p>
                        Exhibition costs range from ₹50,000 to ₹5 lakhs or more, depending on the event scale and location. Expenses include booth design, audiovisual equipment, staffing, and marketing. Virtual exhibitions offer cost-effective alternatives with digital tools and online platforms. Planning involves selecting the right event, preparing compelling content, and coordinating with organizers for optimal exposure.
                    </p>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Benefits of Property Exhibition</h3>
                    <ul className="info-benefits-list-smco">
                        <li><strong>Increased visibility:</strong> Reach a wider audience and generate media attention.</li>
                        <li><strong>Direct sales:</strong> Immediate bookings and on-site transactions.</li>
                        <li><strong>Market insights:</strong> Gather feedback and understand buyer preferences.</li>
                        <li><strong>Brand building:</strong> Establish credibility and differentiate from competitors.</li>
                        <li><strong>Long-term relationships:</strong> Build a database of potential clients for future projects.</li>
                    </ul>
                </div>
            </div>
            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default PropertyExhibitionInfo;
